import { Helmet } from 'react-helmet-async';
import Button from '../common/Button';
import SubInfo from '../common/SubInfo';
import Tags from '../common/Tags';
import PostContent from './PostContent';
import PostHead from './PostHead';
import './PostViewer.scss';

const PostViewer = ({ post, error, loading, actionButtons }) => {
  const { title, body, user, publishedDate, tags } = post || {};

  //에러 발생시
  if (error) {
    if (error.response && error.response.status === 404) {
      return <div className="PostViewer">존재하지 않는 포스트입니다.</div>;
    }
    return <div className="PostViewer">오류 발생!</div>;
  }

  return (
    <div className="PostViewer">
      <Helmet>
        <title>{title ? `${title} - REACTERS` : 'REACTERS'}</title>
      </Helmet>
      {!loading && post && (
        <>
          <PostHead>
            <h1>{title}</h1>
            <SubInfo
              username={user.username}
              publishedDate={publishedDate}
              hasMarginTop
            />
            <Tags tags={tags} />
          </PostHead>
          {actionButtons}
          <PostContent dangerouslySetInnerHTML={{ __html: body }} />
          <div className="GoListButtonWrapper">
            <Button to="/">목록</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PostViewer;
